import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Hero.css';

const Hero = () => {
  const { t } = useTranslation();
  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text" data-aos="fade-right">
            <h1 className="hero-title">
              {t('hero.title')}
            </h1>
            <p className="hero-description">
              {t('hero.description')}
            </p>
            <Link to="/sobre" className="hero-link">{t('hero.action')}</Link>
          </div>
          <div className="hero-image" data-aos="fade-left">
            <picture>
              <source type="image/webp" srcSet="/images/ban_01.webp" />
              <img 
                src="/images/ban_01.png" 
                alt="Mulher segurando dispositivo de autocuidado" 
              />
            </picture>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;


